import React from 'react';
import PropTypes from 'prop-types';

import FormWrapper from '../../../common/formComponents/FormWrapper/FormWrapper';
import AddressRow from '../common/AddressRow/AddressRow';
import UploadField from '../../UploadField/UploadField';
import { fieldNames } from './constants';

const xlsx =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

const getFile = (value) =>
  Array.isArray(value) && value.length ? value[0] : null;

const fileSizeValidator = (_rule, value, callback) => {
  const file = getFile(value);
  if (!file) return;
  const msg = file.size === 0 ? 'Нельзя загружать пустой файл' : undefined;
  callback(msg);
};

const fileFormatValidator = (_rule, value, callback) => {
  const file = getFile(value);
  if (!file) return;
  const msg =
    file.type !== xlsx ? 'Разрешено загружать только xlsx файлы' : undefined;
  callback(msg);
};

export const ChessByFileForm = ({
  form,
  address,
  children,
  progress,
  ...props
}) => {
  return (
    <FormWrapper {...props}>
      <AddressRow address={address} />

      {children}

      <UploadField
        form={form}
        label="Загрузите ваш xlsx файл"
        name={fieldNames.files}
        rules={[
          { required: true, message: 'Обязательное поле' },
          { validator: fileSizeValidator },
          { validator: fileFormatValidator },
        ]}
        uploadProps={{
          accept: xlsx,
          showUploadList: {
            showRemoveIcon: false,
          },
        }}
      />

      {progress}
    </FormWrapper>
  );
};

ChessByFileForm.propTypes = {
  address: PropTypes.string.isRequired,
  form: PropTypes.any.isRequired,
  children: PropTypes.node,
  progress: PropTypes.node,
};
